import { useEffect, useMemo, useState } from "react";

import { PalButton, PalDateHelper, PalDatePicker, PalPage } from "@palamar/fe-library";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";

import styled from "@emotion/styled";
import { Grid } from "@mui/material";

import { setFigureFilter } from "~store/figures/actions";

const FilterButton = styled(PalButton)`
  width: 100%;
  ${({ theme }) => theme.breakpoints.up("md")} {
    width: auto;
  }
`;

const StyledFilterCard = styled.div`
  padding: 20px;
  margin: 10px;
  background-color: ${({ theme }) => theme.palette.grey[100]};
  border-radius: ${({ theme }) => theme.spacing(1)};
`;

const StyledPalDatePicker = styled(PalDatePicker)`
  border-top-left-radius: auto;
  ${({ theme }) => theme.breakpoints.down("md")} {
    &.MuiTextField-root {
      width: 100%;
    }
  }
`;
const DateRangeFilter = ({ params }) => {
  const { start, end } = useMemo(() => {
    return {
      start: params?.[0],
      end: params?.[1],
    };
  }, [params]);

  const dispatch = useDispatch();
  const { t } = useTranslation();
  const [selected, setSelected] = useState("month");

  const [beginDate, setBeginDate] = useState(PalDateHelper.getDateTime().subtract(1, "month"));
  const [endDate, setEndDate] = useState(PalDateHelper.getDateTime());
  const handleDayClick = () => {
    setSelected("day");
    dispatch(
      setFigureFilter({
        [start]: PalDateHelper.getDateTime().subtract(1, "day").format("YYYY-MM-DD"),
        [end]: PalDateHelper.getDateTime().format("YYYY-MM-DD"),
      })
    );
  };
  const handleWeekClick = () => {
    setSelected("week");
    dispatch(
      setFigureFilter({
        [start]: PalDateHelper.getDateTime().subtract(1, "week").format("YYYY-MM-DD"),
        [end]: PalDateHelper.getDateTime().format("YYYY-MM-DD"),
      })
    );
  };
  const handleMonthClick = () => {
    setSelected("month");
    dispatch(
      setFigureFilter({
        [start]: PalDateHelper.getDateTime().subtract(1, "month").format("YYYY-MM-DD"),
        [end]: PalDateHelper.getDateTime().format("YYYY-MM-DD"),
      })
    );
  };
  const handleCustomClick = () => {
    setSelected("custom");
  };

  const handleApplyClick = () => {
    dispatch(
      setFigureFilter({
        [start]: beginDate.format("YYYY-MM-DD"),
        [end]: endDate.format("YYYY-MM-DD"),
      })
    );
  };

  const handleBeginDateChange = (date) => {
    const beginOfMonth = PalDateHelper.getDateTime(date);
    setBeginDate(beginOfMonth);
  };

  const handleEndDateChange = (date) => {
    const endOfMonth = PalDateHelper.getDateTime(date);
    setEndDate(endOfMonth);
  };

  useEffect(() => {
    handleMonthClick();
  }, []);

  return (
    <PalPage>
      <StyledFilterCard>
        <Grid container spacing={2}>
          <Grid container spacing={2}>
            <Grid item md="auto" sm={6} xs={12}>
              <FilterButton fullWidth variant={selected === "day" ? "contained" : "outlined"} onClick={handleDayClick}>
                {t("components.filterCard.yesterday")}
              </FilterButton>
            </Grid>
            <Grid item md="auto" sm={6} xs={12}>
              <FilterButton
                fullWidth
                variant={selected === "week" ? "contained" : "outlined"}
                onClick={handleWeekClick}
              >
                {t("components.filterCard.lastWeek")}
              </FilterButton>
            </Grid>
            <Grid item md="auto" sm={6} xs={12}>
              <FilterButton
                fullWidth
                variant={selected === "month" ? "contained" : "outlined"}
                onClick={handleMonthClick}
              >
                {t("components.filterCard.lastMonth")}
              </FilterButton>
            </Grid>
            <Grid item md="auto" sm={6} xs={12}>
              <FilterButton
                fullWidth
                variant={selected === "custom" ? "contained" : "outlined"}
                onClick={handleCustomClick}
              >
                {t("components.filterCard.custom")}
              </FilterButton>
            </Grid>
          </Grid>
          {selected === "custom" && (
            <Grid container pt={2} spacing={2}>
              <Grid item sm md="auto" xs="12">
                <StyledPalDatePicker
                  disabled={selected !== "custom"}
                  label={t("components.filterCard.beginDate")}
                  openTo="month"
                  value={beginDate}
                  onChange={handleBeginDateChange}
                />
              </Grid>
              <Grid item sm md="auto" xs="12">
                <StyledPalDatePicker
                  disabled={selected !== "custom"}
                  label={t("components.filterCard.endDate")}
                  openTo="month"
                  value={endDate}
                  onChange={handleEndDateChange}
                />
              </Grid>
              <Grid item md="auto" sm="auto" xs="12">
                <FilterButton sx={{ minWidth: 80, height: "100%" }} variant="text" onClick={handleApplyClick}>
                  {t("common.apply")}
                </FilterButton>
              </Grid>
            </Grid>
          )}
        </Grid>
      </StyledFilterCard>
    </PalPage>
  );
};

export default DateRangeFilter;
